import { IPartyForUser, Stream, StreamType } from '../../PartyClientResponse';
import { Button, Input, notification } from 'antd';
import React from 'react';
import BackroomVideo from '../video/BackroomVideo';
import { CopyOutlined } from '@ant-design/icons';
import { channels } from './Cockpit';

const ANTStreamPreview = ({
  party,
  videoId,
  setPreviewStream,
  partyUpdateLoading,
  previewStream,
  muted,
  streamIndex,
  deleteStream,
}: {
  muted?: boolean;
  previewStream: Stream;
  party: IPartyForUser;
  videoId: string;
  streamIndex: number;
  setPreviewStream: (stream: Stream) => void;
  partyUpdateLoading: boolean;
  deleteStream: () => void;
}) => {
  const active =
    party.stage.stream.type === StreamType.Backroom &&
    party.stage.stream.backroomStreamId === videoId;

  const isPreviewing =
    previewStream.type === StreamType.Backroom && previewStream.backroomStreamId === videoId;

  return (
    <div className='ant-preview' style={{ backgroundColor: active ? '#e8417c4d' : 'transparent' }}>
      <div style={{ display: 'flex', height: '100%' }}>
        <div
          style={{
            display: 'flex',
            flex: 1,
            height: '100%',
            // width: 300,
            overflow: 'hidden',
            flexShrink: 1,
            justifyContent: 'center',
          }}>
          <BackroomVideo
            muted={muted}
            height={'100%'}
            width={'100%'}
            id={videoId}
            transitionLength={party.stage.transitionLength}
          />
        </div>
        <div
          style={{
            paddingLeft: '1em',
            justifyContent: 'flex-start',
            minWidth: 130,
          }}>
          <div style={{ marginBottom: '0,5em' }}>
            <h3 style={{ display: 'flex', justifyContent: 'space-between', color: 'white' }}>
              {channels[streamIndex]}
              {active && (
                <div
                  style={{
                    display: 'inline-flex',
                    backgroundColor: '#e25684',
                    borderRadius: 12,
                    padding: '0 10px',
                    color: 'white',
                    marginLeft: '0.5em',
                  }}>
                  LIVE
                </div>
              )}
            </h3>
          </div>
          <div>
            <div style={{ display: 'flex' }}>
              <Input value={videoId} style={{ marginBottom: '0.5em', marginRight: '0.5em' }} />
              <Button
                type='default'
                // style={{ width: '100%' }}
                onClick={() => {
                  navigator.clipboard.writeText(videoId);
                  notification.success({
                    message: 'stream key copied to clipboard!',
                  });
                }}>
                <CopyOutlined />
              </Button>
            </div>
          </div>
          <div>
            <Button
              loading={partyUpdateLoading}
              type={isPreviewing ? 'primary' : 'dashed'}
              // danger={active}
              disabled={isPreviewing}
              style={{ width: '100%', marginBottom: '0.5em' }}
              onClick={() =>
                setPreviewStream({
                  type: StreamType.Backroom,
                  backroomStreamId: videoId,
                  audioSource: 'audio-follows-video',
                })
              }>
              {isPreviewing ? 'previewing' : 'preview'}
            </Button>
          </div>
          <div>
            <Button
              type='dashed'
              style={{ width: '100%' }}
              onClick={() => {
                deleteStream();
              }}>
              <CopyOutlined /> delete stream
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ANTStreamPreview;
